import { render, staticRenderFns } from "./ProductCutoffTimesConfigurations.vue?vue&type=template&id=2a8f9da6&scoped=true&"
import script from "./ProductCutoffTimesConfigurations.vue?vue&type=script&lang=js&"
export * from "./ProductCutoffTimesConfigurations.vue?vue&type=script&lang=js&"
import style0 from "./ProductCutoffTimesConfigurations.vue?vue&type=style&index=0&id=2a8f9da6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8f9da6",
  null
  
)

export default component.exports